const FAQ = [
  { q: 'Bagaimana cara login ke CERAH Pedia?', a: 'Gunakan nama pengguna dan password yang diberikan oleh administrator CERAH. Jika belum punya akun, hubungi admin di admin@cerah.id.' },
  { q: 'Bagaimana cara mencari dokumen?', a: 'Gunakan kotak pencarian di bagian atas halaman atau navigasi sidebar untuk menemukan dokumen berdasarkan kategori.' },
  { q: 'Bagaimana cara mengunduh dokumen?', a: 'Buka dokumen yang ingin diunduh, lalu klik tombol "Unduh" di sebelah kanan kartu dokumen.' },
  { q: 'Apa itu Ringkasan Pengetahuan?', a: 'Ringkasan Pengetahuan di dashboard menampilkan jumlah total konten berdasarkan tipe: Bank Data, Dokumen, Publikasi, Laporan, Infografik, dan Media.' },
  { q: 'Bagaimana jika lupa password?', a: 'Klik "Lupa password?" di halaman login, atau hubungi administrator CERAH untuk reset password.' },
]

export default function Bantuan() {
  return (
    <div className="p-6 max-w-2xl">
      <h1 className="text-xl font-bold text-gray-800 dark:text-white mb-1">Bantuan & FAQ</h1>
      <p className="text-sm text-gray-400 mb-6">Pertanyaan yang sering ditanyakan</p>
      <div className="flex flex-col gap-3">
        {FAQ.map((item, i) => (
          <div key={i} className="bg-white dark:bg-gray-800 rounded-xl border border-gray-100 dark:border-gray-700 p-4">
            <p className="text-sm font-semibold text-gray-800 dark:text-white mb-1.5">{item.q}</p>
            <p className="text-sm text-gray-500 dark:text-gray-400 leading-relaxed">{item.a}</p>
          </div>
        ))}
      </div>
      <div className="mt-6 p-4 bg-cerah-teal-light rounded-xl border border-cerah-teal/20">
        <p className="text-sm font-medium text-cerah-teal mb-1">Butuh bantuan lebih lanjut?</p>
        <p className="text-xs text-cerah-teal/70">Hubungi administrator CERAH: <a href="mailto:admin@cerah.id" className="underline">admin@cerah.id</a></p>
      </div>
    </div>
  )
}
